import { closestField } from './utils'

export const enhanceMovePhoneField = (root) => {
	const contact = root.querySelector('#contact.wc-block-components-address-form')
	if (!contact) return

	const email = contact.querySelector('input#email')
	const phone = root.querySelector('input[name*="phone"], input[id*="phone"]')
	if (!email || !phone) return

	const emailWrap = closestField(email)
	const phoneWrap = closestField(phone)
	if (!emailWrap || !phoneWrap) return

	if (emailWrap.nextElementSibling === phoneWrap) return
	emailWrap.insertAdjacentElement('afterend', phoneWrap)
}
